import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useServiceOrdersState = () => React.useContext(Context) || {}
export const useServiceOrders = () => useServiceOrdersState()?.serviceOrders || []

const QUERY = gql`
  query ServiceOrders($page: Int, $limit: Int, $search: String) {
    serviceOrders(page: $page, limit: $limit, search: $search, sort: { field: ID, type: DESC }) {
      id
      yearlyId
      insertedAt
    }
  }
`

const ServiceOrdersLoader = ({ children, search, perPage: limit, uncontrolledChildren }) => {
  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: limit || 24,
      search,
      sort: { field: 'ID', type: 'DESC' }
    },
    client: serviceOrdersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default ServiceOrdersLoader
